"use client";

import "./carousel.css";
import { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";

export default function HeroBanner({
  oldBannerData,
  desktopBannerData,
  tabletBannerData,
  mobileBannerData,
}: any) {
  const sliderRef = useRef<Slider | null>(null);
  const pathname = usePathname();
  const getDesktopBanner = () =>
    desktopBannerData?.length > 0 ? desktopBannerData : oldBannerData;
  const [bannerData, setBannerData] = useState(getDesktopBanner());
  useEffect(() => {
    const updateBannerData = () => {
      const desktopData = getDesktopBanner();

      if (window.innerWidth <= 550) {
        setBannerData(
          mobileBannerData?.length > 0 ? mobileBannerData : desktopData,
        );
      } else if (window.innerWidth <= 768) {
        setBannerData(
          tabletBannerData?.length > 0 ? tabletBannerData : desktopData,
        );
      } else {
        setBannerData(desktopData);
      }
    };
    updateBannerData();
    window.addEventListener("resize", updateBannerData);
    return () => window.removeEventListener("resize", updateBannerData);
  }, [oldBannerData, desktopBannerData, tabletBannerData, mobileBannerData]);

  const isContactPage = pathname === "/contact-us";
  //show the locate us instead of banner
  if (isContactPage) {
    return (
      <section className="hero-banner-section">
        {/* <div
          className="hero-banner-inner d-flex align-items-center justify-content-center "
          style={{
            minHeight: "300px",
            background: "#f5f5f5",
          }}
        > */}
        <h1
          className=" d-flex align-items-center justify-content-center "
          style={{
            fontSize: "42px",
            fontWeight: 700,
            color: "#222",
          }}
        >
          Locate us at
        </h1>
        {/* </div> */}
      </section>
    );
  }

  if (!bannerData || bannerData.length === 0) return null;

  const multiple = bannerData.length > 1;

  const settings = {
    dots: true,
    arrows: false,
    infinite: multiple,
    speed: 600,
    autoplay: multiple,
    autoplaySpeed: 4500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // centerMode shows a "peek" of the next banner on the right/left (OSE style)
    centerMode: multiple,
    centerPadding: "120px",
    pauseOnHover: true,
    dotsClass: "slick-dots hero-dots",
    responsive: [
      { breakpoint: 1400, settings: { centerPadding: "80px" } },
      { breakpoint: 1024, settings: { centerPadding: "48px" } },
      {
        breakpoint: 768,
        settings: { centerMode: false, centerPadding: "0px" },
      },
    ],
  };

  return (
    <section className="hero-banner-section">
      <div className="hero-banner-inner">
        <Slider {...settings} ref={sliderRef}>
          {bannerData.map((item: any) => (
            <div key={item.id} className="hero-slide">
              <div className="hero-slide-card">
                {item.URL ? (
                  <Link
                    href={item.URL}
                    passHref
                    style={{ display: "block", width: "100%", height: "100%" }}
                  >
                    <Image
                      src={item.Image_Path}
                      alt="Banner"
                      fill
                      sizes="100vw"
                      style={{ objectFit: "cover", objectPosition: "center" }}
                      priority
                    />
                  </Link>
                ) : (
                  <Image
                    src={item.Image_Path}
                    alt="Banner"
                    fill
                    sizes="100vw"
                    style={{ objectFit: "cover", objectPosition: "center" }}
                    priority
                  />
                )}
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
